import * as React from 'react'

export const Dots = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg {...props} strokeWidth="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <circle cx="256" cy="256" r="26"></circle>
      <circle cx="256" cy="346" r="26"></circle>
      <circle cx="256" cy="166" r="26"></circle>
      <path
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="32"
        d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      ></path>
    </svg>
  )
}
